<template>
  <div class="error-view">
    <iframe v-if="isShowLinkToIframe" :src="errorsView.viewUrl"></iframe>
    <iframe v-if="!isShowLinkToIframe" ref="errorsViewIframeInnerPage"></iframe>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ErrorsStatusesView",
  computed: {
    ...mapGetters([
      "appData",
      "errorsView",
      "widgetData",
      "alertData",
      "afterChatView",
      // ...
    ]),
    isShowLinkToIframe() {
      return this.errorsView.viewUrl && this.errorsView.viewUrl !== "";
    },
  },
  mounted() {
    //if url doesnt exist on json file
    if (this.$refs.errorsViewIframeInnerPage) {
      //inject HTML to Iframe
      this.$refs.errorsViewIframeInnerPage.contentWindow.document.write(
        this.$store.state.errorPage
      );
    }
  },
};
</script>

<style scoped>
.title-icon {
  padding-right: 5px;
}
.error-view {
  height: calc(100% - 40px);
}
iframe {
  width: 100%;
  height: 100%;
}
</style>
